// This file was auto-generated by Fern from our API Definition.
export const LlmCustomProviderKind = {
    Custom: "custom",
    Azure: "azure",
    Bedrock: "bedrock",
    Sagemaker: "sagemaker",
    VertexAi: "vertex_ai",
    Openai: "openai",
    Cohere: "cohere",
    Anyscale: "anyscale",
    Deepinfra: "deepinfra",
    Alephalpha: "alephalpha",
    Groq: "groq",
    Minimax: "minimax",
    Mistral: "mistral",
    Mistralai: "mistralai",
    Anthropic: "anthropic",
    Perplexityai: "perplexityai",
    TogetherAi: "together_ai",
    Openrouter: "openrouter",
    Gemini: "gemini",
    Xai: "xai",
};
